import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";

export default function AdminLayout() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
  return (
    <div className="min-h-screen" style={{ background: "var(--bg-base)" }} data-testid="admin-layout">
      <Outlet />
    </div>
  );
}
